import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=38d9b716"
import script from "./CaseList.vue?vue&type=script&lang=js"
export * from "./CaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports